import './SliderRange.97e9e00c356c92d68fd03e88c36a995f.css';
export default {"range":"_range_pp8ig_1"};